/**
 * A text of the buy screens which names a number, such as "In your cart:
 * {count} items" or "{count} images selected".
 *
 * The page hands the template over in a data attribute of the element and the
 * singular form, the language key with `_1`, in the same attribute with `-one`
 * (data-template / data-template-one). For one the singular form is used, so
 * the text does not read "1 items"; a page without it, for example an older
 * snippet override, keeps the plural form. `{count}` is filled in; any other
 * placeholder is left to the caller.
 */
export function countText(element: Element, attribute: string, count: number): string {
    const template = (count === 1 && element.getAttribute(attribute + '-one'))
        || element.getAttribute(attribute)
        || '';
    return template.replace('{count}', String(count));
}
